import { Button, Grid, Hidden, Typography } from "@material-ui/core";
import React from "react";
import useStyles from "screens/Counter/style";
import CloudDownloadRoundedIcon from "@material-ui/icons/CloudDownloadRounded";
import Apis from "constants/Api";
export function AttachCard({ name, url }) {
	const classes = useStyles();
	return (
		<Grid container alignItems="center" justify="space-between" className={classes.attachCardContainer}>
			<Hidden smDown>
				<Typography variant="h5">{name}</Typography>
				<a href={Apis.imageUrl + url} download className={classes.attachCardDownloadBtn}>
					<CloudDownloadRoundedIcon style={{ color: "#f2f2f2", marginLeft: "10px" }} />
					<Typography variant="h6" style={{ color: "#fff" }}>
						دانلود
					</Typography>
				</a>
			</Hidden>
			<Hidden mdUp>
				<Grid container>
					<Typography variant="h5">{name}</Typography>
				</Grid>
				<Grid container justify="flex-end" style={{ marginTop: "25px" }}>
					<a
						href={Apis.imageUrl + url}
						download
						className={classes.attachCardDownloadBtn}
					>
						<CloudDownloadRoundedIcon style={{ color: "#f2f2f2", marginLeft: "10px" }} />
						<Typography variant="h6" style={{ color: "#fff" }}>
							دانلود
						</Typography>
					</a>
				</Grid>
			</Hidden>
		</Grid>
	);
}
